import { render } from "./TelebarqGM_output.vue?vue&type=template&id=2dbdbde2&scoped=true"
import script from "./TelebarqGM_output.vue?vue&type=script&lang=js"
export * from "./TelebarqGM_output.vue?vue&type=script&lang=js"

import "./TelebarqGM_output.vue?vue&type=style&index=0&id=2dbdbde2&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbdbde2"]])

export default __exports__